<template>
  <div class="d-flex align-items-center justify-content-center feedback-link">
    <div class="text-center">
      <template v-if="error">
        <h3 class="mb-3">Unable to open this feedback</h3>
        <p class="text-muted mb-4">{{ error }}</p>
        <router-link :to="{ name: 'login' }" class="btn btn-primary">Go to dashboard</router-link>
      </template>
      <template v-else>
        <b-spinner></b-spinner>
        <p class="text-muted mt-3">Opening feedback...</p>
      </template>
    </div>
  </div>
</template>

<script>
import { userUsesNewUiEligible } from '@utils/userUsesNewUiEligible'

export default {
  name: 'FeedbackLink',
  data() {
    return {
      error: null,
    }
  },
  computed: {
    businessId() {
      return Number(this.$route.params.businessId)
    },
    feedbackId() {
      return Number(this.$route.params.feedbackId)
    },
  },
  async mounted() {
    if (!this.$store.getters['auth/isLoggedIn']) {
      this.goToLogin()
      return
    }
    try {
      let user = this.$store.getters['auth/user'] || (await this.$store.dispatch('auth/getProfile'))

      // Drop an impersonation of a different business before entering the right one.
      if (!this.isCurrentBusiness(user) && localStorage.getItem('main_access_token')) {
        await this.$store.dispatch('auth/stopImpersonate')
        user = await this.$store.dispatch('auth/getProfile')
      }

      if (!this.isCurrentBusiness(user)) {
        await this.enterBusiness(user)
        user = await this.$store.dispatch('auth/getProfile')
      }

      if (!this.isCurrentBusiness(user)) {
        throw new Error('You do not have access to this business.')
      }

      this.$router.replace({
        name: userUsesNewUiEligible(user) ? 'new-business.reviews' : 'business.reviews',
        query: { tab: 'feedback', feedback: String(this.feedbackId) },
      })
    } catch (e) {
      if (e?.response?.status === 401) {
        this.goToLogin()
        return
      }
      this.error = e?.response?.status === 403 || e?.response?.status === 404
        ? 'This feedback could not be found, or your account does not have access to it.'
        : e?.message || 'Something went wrong. Please try again.'
    }
  },
  methods: {
    goToLogin() {
      this.$router.replace({ name: 'login', query: { redirect_url: this.$route.fullPath } })
    },
    isCurrentBusiness(user) {
      return !!user && user.role === 'Business' && Number(user.business?.id) === this.businessId
    },
    async enterBusiness(user) {
      if (user.role === 'Team') {
        const team = (user.teams || []).find((t) => Number(t.business_id) === this.businessId)
        if (!team) {
          throw new Error('You do not have access to this business.')
        }
        return this.$store.dispatch('auth/impersonateTeam', team.id)
      }
      const res = await this.$store.dispatch('reviews/getFeedback', {
        businessId: this.businessId,
        feedbackId: this.feedbackId,
      })
      const businessUserId = res?.business?.user_id
      if (!businessUserId) {
        throw new Error('This business does not have a login user yet, so its feedback cannot be opened.')
      }
      return this.$store.dispatch('auth/impersonate', businessUserId)
    },
  },
}
</script>

<style lang="scss" scoped>
.feedback-link {
  min-height: 80vh;
  padding: 20px;
}
</style>
